module.exports = __webpack_public_path__ + "images/mobile/coupons/xwz-qrcode-3257d7574a9095d9312ae2b87b5797c7.png";